<footer class="footer">
  <div class="container text-right">
    <span class="text-muted">{{ AppHubVersion }}</span>
  </div>
</footer>
